export default function useREM(multiple: number): string | number {
  return `${multiple}rem`;
}
